/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { Col } from 'react-bootstrap';

import api from 'services/api';

import { Text, Select } from 'v3/components';

import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';

export default function PaymentMethod({ data, setData, errors, loading }) {

  const [options, setOptions] = useState([]);

  async function initialFetchPaymentMethods() {
    try {
      const response = await api.get('payment/methods', {
        params: { initialFetch: true },
      });

      setOptions(response.data);

    } catch (ex) {
      setOptions([]);
    }
  }

  useEffect(() => {
    initialFetchPaymentMethods();
  }, []);

  return (
    <Card
      LoadingBodyComponent={() => (
        <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
      )}
      header={
        <Text color="#464E5F" type="header">
          Método de pagamento
        </Text>
      }
    >

      <Col xl={6} lg={6} md={12} xs={12}>
        <Select
          label="Método de pagamento *"
          value={data}
          options={options}
          onChange={value => setData(value)}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          error={errors?.['paymentMethod']}
          isDisabled={loading}
        />
      </Col>
    </Card>
  );
}
